import { Slider } from "@/components/ui/slider";

const Seg = ({ value, options, onChange, testId }) => (
  <div className="flex rounded-md border border-[#E5E7EB] overflow-hidden" data-testid={testId}>
    {options.map(([v, l]) => (
      <button key={v} type="button" onClick={() => onChange(v)} data-testid={`${testId}-${v}`}
        className={`flex-1 text-xs h-8 px-2 transition-colors ${value === v ? "bg-[#111] text-white" : "bg-white hover:bg-gray-50"}`}>{l}</button>
    ))}
  </div>
);

const Row = ({ label, children }) => <div className="space-y-1.5"><div className="text-[11px] font-bold uppercase tracking-wider text-gray-600">{label}</div>{children}</div>;

const Range = ({ value, min, max, step, onChange, testId, fmt }) => (
  <div className="flex items-center gap-3">
    <Slider value={[value]} min={min} max={max} step={step} onValueChange={([v]) => onChange(v)} data-testid={testId} className="flex-1" />
    <span className="text-xs font-mono w-12 text-right">{fmt(value)}</span>
  </div>
);

const pct = (v) => `${Math.round(v * 1000) / 10}%`;

export const TextBoxControls = ({ b, set, prefix }) => (
  <div className="space-y-4">
    <Row label="Typeface"><Seg value={b.font} onChange={(font) => set({ font })} options={[["serif", "Serif"], ["sans", "Sans"], ["mono", "Mono"]]} testId={`${prefix}-font`} /></Row>
    <Row label="Style"><Seg value={b.style} onChange={(style) => set({ style })} options={[["regular", "Regular"], ["bold", "Bold"], ["italic", "Italic"]]} testId={`${prefix}-style`} /></Row>
    <Row label="Alignment"><Seg value={b.align} onChange={(align) => set({ align })} options={[["left", "Left"], ["center", "Centre"], ["right", "Right"]]} testId={`${prefix}-align`} /></Row>
    <Row label="Text size"><Range value={b.size} min={0.01} max={0.15} step={0.002} onChange={(size) => set({ size })} testId={`${prefix}-size`} fmt={pct} /></Row>
    <Row label="Box width"><Range value={b.w} min={0.1} max={1} step={0.01} onChange={(w) => set({ w })} testId={`${prefix}-width`} fmt={pct} /></Row>
    <Row label="Colour">
      <div className="flex items-center gap-2">
        <input type="color" value={b.color} onChange={(e) => set({ color: e.target.value })} className="h-8 w-12 rounded border cursor-pointer" data-testid={`${prefix}-color`} />
        <span className="font-mono text-xs">{b.color}</span>
      </div>
    </Row>
  </div>
);

export const QrControls = ({ b, set }) => (
  <Row label="QR code size"><Range value={b.size} min={0.04} max={0.3} step={0.005} onChange={(size) => set({ size })} testId="cert-qr-size" fmt={pct} /></Row>
);
